import React from "react";
import { Flex } from "@jsq/ds/core";
import { rowInputContainer } from "./styles_vanilla.css";

type FormSelectFlexProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * A component that represents a row in an input form.
 *
 * @component
 * @example
 * ```tsx
 * <SimpleFormRow>
 *   <input type="text" />
 *   <button>Submit</button>
 * </SimpleFormRow>
 * ```
 */
export const SimpleFormRow: React.FC<FormSelectFlexProps> = ({ children }) => {
  return <Flex className={rowInputContainer}>{children}</Flex>;
};
